// app/javascript/controllers/cart_button_controller.js
import { Controller } from "@hotwired/stimulus"
import Toastify from 'toastify-js'

export default class extends Controller {
  static values = { itemType: String, itemId: String, cartItemId: String }

  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content;
  }

  updateCartCountDisplay(newCount) {
    const countElements = document.querySelectorAll('.cart-items-count');
    countElements.forEach(element => {
      element.textContent = newCount;
    });
  }

  updateSubtotalDisplay(newSubtotal) {
    document.querySelectorAll('.subtotal-display').forEach(element => {
      element.textContent = newSubtotal;
    });
  }

  addToCart(event) {
    event.preventDefault();
    const url = `/cart_items`;
    const data = { 
      item_type: this.itemTypeValue, 
      item_id: this.itemIdValue,  // Using the item ID to add to cart
      authenticity_token: this.getCsrfToken()
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCsrfToken()
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      this.updateCartCountDisplay(data.cart_items_count);
      this.updateSubtotalDisplay(data.total_price);
      Toastify({
        text: "Item added to cart successfully.",
        duration: 4000,
        close: true,
        position: "right",
        className: "success",
        stopOnFocus: true,
      }).showToast();
    })
    .catch(error => {
      console.error('There was a problem with your fetch operation:', error);
      Toastify({
        text: "There was an issue adding the item to the cart.",
        duration: 4000,
        close: true,
        position: "right",
        className: "error",
        stopOnFocus: true,
      }).showToast();
    });
  }

  confirmRemove(event) {
    event.preventDefault();
    if (confirm('Are you sure you want to remove this item?')) {
      this.removeFromCart(event);
    }
  }

  updatePaymentIntent(paymentIntentId) {
    fetch(`/update_checkout`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCsrfToken()
      },
      body: JSON.stringify({})
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      if (data.clientSecret) {
        // Update the Stripe Elements or UI with new clientSecret
        const event = new CustomEvent('payment-intent-updated', { 
          detail: { clientSecret: data.clientSecret } 
        });
        window.dispatchEvent(event);
      }
    })
    .catch(error => console.error('Error updating payment intent:', error));
  }

  removeFromCart(event) {
    event.preventDefault();
    const itemElement = document.getElementById(`item-${this.itemTypeValue}-${this.cartItemIdValue}`);
    if (!itemElement) return;

    const url = `/cart_items/${this.cartItemIdValue}`;  // Using the cart item ID to remove from cart
    const data = {
      authenticity_token: this.getCsrfToken()
    };

    fetch(url, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': this.getCsrfToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      this.updateCartCountDisplay(data.cart_items_count);
      this.updateSubtotalDisplay(data.total_price);
      itemElement.remove(); // Removes the item from the DOM
      Toastify({
        text: "Cart item removed successfully.",
        duration: 3000,
        close: true,
        position: "right",
        className: "success",
        stopOnFocus: true
      }).showToast();
    })
    .catch(error => {
      console.error('There was a problem with your fetch operation:', error);
      Toastify({
        text: "Unable to remove cart item.",
        duration: 3000,
        close: true,
        position: "right",
        className: "error",
        stopOnFocus: true
      }).showToast();
    });
  }
}
